export const GET_PAYMENT_REQUEST = 'GET_PAYMENT_REQUEST';
export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS';
export const GET_PAYMENT_REJECT = 'GET_PAYMENT_REJECT';
export const GET_PAYMENT_HISTORY_REQUEST = 'GET_PAYMENT_HISTORY_REQUEST';
export const GET_PAYMENT_HISTORY_SUCCESS = 'GET_PAYMENT_HISTORY_SUCCESS';
export const GET_PAYMENT_HISTORY_REJECT = 'GET_PAYMENT_HISTORY_REJECT';
export const REGISTER_PAYMENT_SUCCESS = 'REGISTER_PAYMENT_SUCCESS';
export const GET_NEXT_PAYMENT_REQUEST = 'GET_NEXT_PAYMENT_REQUEST';
export const GET_NEXT_PAYMENT_SUCCESS = 'GET_NEXT_PAYMENT_SUCCESS';
export const GET_NEXT_PAYMENT_REJECT = 'GET_NEXT_PAYMENT_REJECT';
export const GET_PAYMENT_DETAILS_REQUEST = 'GET_PAYMENT_DETAILS_REQUEST';
export const GET_PAYMENT_DETAILS_SUCCESS = 'GET_PAYMENT_DETAILS_SUCCESS';
export const GET_PAYMENT_DETAILS_REJECT = 'GET_PAYMENT_DETAILS_REJECT';



// WEBPACK FOOTER //
// ./src/payment/constants.js